import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface TermsOfServiceProps {
  onBack: () => void;
}

export const TermsOfService: React.FC<TermsOfServiceProps> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="font-medium">Volver</span>
        </button>

        <article className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-black text-gray-900 mb-4">Condiciones de Servicio</h1>
          <p className="text-xl text-gray-600 mb-8">Condiciones de Servicio de programatuviaje.cl</p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Aceptación</h2>
            <p className="text-gray-700 leading-relaxed">
              Al utilizar este sitio, el usuario acepta los presentes términos. Si no está de acuerdo, debe abstenerse de usar la plataforma.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Uso del sitio</h2>
            <p className="text-gray-700 leading-relaxed">
              El usuario se compromete a hacer un uso lícito y adecuado de la aplicación. Queda prohibido cualquier uso que dañe o sature los sistemas.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Responsabilidad</h2>
            <p className="text-gray-700 leading-relaxed">
              La aplicación se ofrece "tal cual". No nos hacemos responsables por errores, pérdida de datos o decisiones tomadas basadas en el contenido del sitio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Modificaciones</h2>
            <p className="text-gray-700 leading-relaxed">
              Nos reservamos el derecho de modificar el servicio o estas condiciones sin previo aviso para adaptarnos a mejoras técnicas o cambios legales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Soporte</h2>
            <p className="text-gray-700 leading-relaxed">
              El canal oficial de comunicación para reportar incidencias es programatuviajeadm@gmail.com.
            </p>
          </section>
        </article>
      </div>
    </div>
  );
};

